<template>
  <div class="no-pass-container">
    <div class="content-wrapper">
      <!-- 动画锁图标 -->
      <div class="icon-wrapper">
        <div class="lock-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="lock-svg"
          >
            <path
              d="M12 2C9.23858 2 7 4.23858 7 7V9H6C4.89543 9 4 9.89543 4 11V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V11C20 9.89543 19.1046 9 18 9H17V7C17 4.23858 14.7614 2 12 2Z"
              fill="currentColor"
            />
            <path
              d="M12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14Z"
              fill="white"
              opacity="0.9"
            />
            <path
              d="M9 9V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7V9H9Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>

      <!-- 主要文本 -->
      <h1 class="title">访问受限</h1>
      <p class="subtitle">您没有权限访问此页面</p>

      <!-- 分隔线 -->
      <div class="divider"></div>

      <!-- 提示信息 -->
      <div class="message-box">
        <p class="message">
          抱歉，您的账户暂无访问该资源的权限。<br />
          如需开通，请联系系统管理员。
        </p>
      </div>

      <!-- 可选的操作按钮 -->
      <div class="actions">
        <button class="btn btn-primary" >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="btn-icon"
          >
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          返回上一页
        </button>
        <button class="btn btn-secondary">
          前往首页
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="btn-icon-right"
          >
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>

    <!-- 背景装饰 -->
    <div class="bg-decoration">
      <div class="blob blob-1"></div>
      <div class="blob blob-2"></div>
      <div class="blob blob-3"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoPass",
  methods: {
    goBack() {
    //   this.$router.go(-1);
    },
    goHome() {
    //   this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.no-pass-container {
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(135deg, #f5f7fa 0%, #e9edf2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

.content-wrapper {
  position: relative;
  z-index: 10;
  max-width: 500px;
  width: 90%;
  padding: 3rem 2rem;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 2.5rem;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25),
    0 0 0 1px rgba(255, 255, 255, 0.5);
  text-align: center;
  transition: transform 0.3s ease;
}

.content-wrapper:hover {
  transform: translateY(-5px);
}

/* 锁图标样式 */
.icon-wrapper {
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
}

.lock-icon {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #ef4444, #dc2626);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 20px 35px -10px rgba(239, 68, 68, 0.4);
  animation: float 3s ease-in-out infinite;
}

.lock-svg {
  width: 56px;
  height: 56px;
  color: white;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

/* 文字样式 */
.title {
  font-size: 2.5rem;
  font-weight: 800;
  background: linear-gradient(135deg, #1e293b, #334155);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin: 0 0 0.5rem 0;
  letter-spacing: -0.02em;
}

.subtitle {
  font-size: 1.1rem;
  color: #64748b;
  margin: 0 0 1.5rem 0;
  font-weight: 500;
}

/* 分隔线 */
.divider {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #ef4444, #f97316);
  border-radius: 2px;
  margin: 1rem auto 1.5rem auto;
}

/* 消息框 */
.message-box {
  background: #fef2f2;
  border-left: 4px solid #ef4444;
  border-radius: 1rem;
  padding: 1rem 1.5rem;
  margin: 1.5rem 0;
}

.message {
  color: #7f1d1d;
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
}

/* 按钮样式 */
.actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
  flex-wrap: wrap;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border-radius: 2rem;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  background: none;
  font-family: inherit;
}

.btn-primary {
  background: white;
  color: #1e293b;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.btn-primary:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
}

.btn-secondary {
  background: linear-gradient(135deg, #1e293b, #0f172a);
  color: white;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.btn-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  filter: brightness(1.05);
}

.btn-icon,
.btn-icon-right {
  width: 18px;
  height: 18px;
}

/* 背景动画装饰 */
.bg-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
}

.blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.5;
  animation: blobMove 20s infinite alternate;
}

.blob-1 {
  width: 300px;
  height: 300px;
  background: #ef4444;
  top: -100px;
  left: -100px;
  animation-duration: 25s;
}

.blob-2 {
  width: 400px;
  height: 400px;
  background: #f97316;
  bottom: -150px;
  right: -150px;
  animation-duration: 30s;
  animation-delay: -5s;
}

.blob-3 {
  width: 250px;
  height: 250px;
  background: #3b82f6;
  top: 40%;
  left: 30%;
  animation-duration: 28s;
  animation-delay: -10s;
  opacity: 0.3;
}

/* 动画 */
@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes blobMove {
  0% {
    transform: translate(0, 0) scale(1);
  }
  100% {
    transform: translate(50px, 50px) scale(1.1);
  }
}

/* 响应式调整 */
@media (max-width: 640px) {
  .content-wrapper {
    padding: 2rem 1.5rem;
  }

  .title {
    font-size: 2rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .lock-icon {
    width: 80px;
    height: 80px;
  }

  .lock-svg {
    width: 44px;
    height: 44px;
  }

  .btn {
    padding: 0.6rem 1.2rem;
    font-size: 0.85rem;
  }

  .actions {
    gap: 0.75rem;
  }
}
</style>